import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';
import ReactIcon from '../../Images/react.png'

const Footer = () => {
    const theme = useContext(ThemeContext);
    return ( 
        <div className="footer" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground, borderColor:theme.currentTheme.borderColor}}>
            <h5>Made with <img className="react-icon" src={ReactIcon} alt="React JS" height="14" width="14" /> by Shahbaz Khan</h5>
        </div>
     );
}
 
export default Footer;